module.exports = __webpack_public_path__ + "img/7.544e3dd8.png";